module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_13.a494843c.svg";